import { MdOutlineMenuBook } from 'react-icons/md';
import { Button } from '@Components/Button';
import { Appearance, Size } from '@Components/designConstants';

interface GlossaryButtonProps {
  onClick: () => void;
}

export const GlossaryButton = ({ onClick }: GlossaryButtonProps) => (
  <Button
    size={Size.LG}
    appearance={Appearance.OUTLINED}
    className='dtc-commerce-mmm-glossary-trigger'
    leadingElement={<MdOutlineMenuBook />}
    onClick={onClick}
  >
    Glossary
  </Button>
);
